<template>  


      <div class="col-12">
          <div class="card border-0">
            <div class="card-header font-weight-bold bg-transparent border-0">Edit an Include</div>
            <div class="card-body pt-0">

              <div class="row">
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Include Content</small>
                    </div>
                    <div class="input-group col-12 mb-3">
                      <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="inc_name">
                    </div>
                  </div>
                  
                </div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-12">
                      <small class="">Include Status</small>
                    </div>
                    <div class="input-group col-12 mb-3">
                      <select class="form-control" v-model="inc_status">
                        <option value="0">Active</option>
                        <option value="1">In-Active</option>
                      </select>
                    </div>
                  </div>
                  
                </div>
              </div>
            

              <div class="row">
                <div class="col-12">
                  <button @click="cancelEdit" class="btn btn-danger">Close</button>
                  <button @click="submitForm" class="btn btn-success">Save Changes</button>
                </div>
              </div>
            </div><!--  end card-body -->
          </div><!--  end card -->
      </div>
      


</template>


<script>
import {store} from '../../../stores/admin-product-single-main-store.js'




export default {
  props: ['prop1', 'prop2', 'prop3'],
  store,
  data: function () {
    return { 
      inc_name: '',
      inc_order: '',
      inc_status: '0',
      includeDetails: [],
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },
    detailsComp () { return this.$store.state.detailsComp },
  },
  watch: {
    
  },
  mounted() {
    this.getIncludeDetails();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    getIncludeDetails() {
      var _this = this;
      axios.get('/admin/utility/product/getspecificincludes/' + _this.prop3[0])
        .then(function (response) {
        var a = response.data.data;
        if(a == null || a == ''){ var b = []; } else { var b = a; }
          _this.includeDetails = b;
          _this.inc_name = _this.includeDetails.name;
          _this.inc_status = _this.includeDetails.status;    
        });
    },
    validateForm() {
      var _this = this;
      var valErrors = [];

      if(_this.inc_name == '' || _this.inc_name == null || _this.inc_name.length < 3 ){ valErrors.push("Valid content is required, the content cannot be empty, nor include less than 3 characters!")  } 
      if(_this.inc_status != 0 && _this.inc_status != 1){ valErrors.push("A status selection is required!")  } 

      if( valErrors.length > 0) {
        _this.errorDisplay(valErrors);
        return false;
      } else {
        return true;
      }
    },
    submitForm() {
      var _this = this;
      var a = _this.validateForm();
      if(a == false) {
        return false;
      }
      _this.$toastr.warning('Updating product include information.', 'Please wait!')
      axios.post( '/admin/utility/product/includes/update', {
        inc_id: _this.prop3[0],
        name: _this.inc_name,
        status: _this.inc_status,
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['edit-include']);
      }) //end then
      .catch(function (error) {
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
    cancelEdit() {
      var _this = this;
      _this.$emit('onUComplete', [ 'edit-include' ])
    }
  },    
  components:{

    
  },
  filters: {

  }
}
</script>
